export default __webpack_public_path__ + "static/media/set-live-background.e2c2e116.png";